import React from 'react';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {StackParamList} from '../../../../navigators';
import {SuccessTemplate} from '../../../../components/templates/success';
import {PrimaryButton} from '../../../../components/buttons';
import {message} from '../../../../utils/messages';

type ScreenProps = NativeStackScreenProps<StackParamList, 'SendSuccess'>;

export const SendSuccessScreen = ({navigation}: ScreenProps) => {
  const handlePrimaryPress = async () => {
    navigation.navigate('BalanceList');
  };

  return (
    <SuccessTemplate
      title={message('send-success-title')}
      summary={message('send-success-summary')}>
      <PrimaryButton
        label={message('send-success-primary-button')}
        onPress={() => handlePrimaryPress()}
      />
    </SuccessTemplate>
  );
};
